export const slugify = string => {
    if (typeof string !== 'string') {
        return '';
    }

    return string
        .trim()
        .toLowerCase()
        .replace(/[^\w]+/gi, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};
